import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import CancelButton from '../../core/CancelButton';
import PrimaryButton from '../../core/PrimaryButton';
import { globalStyles as styles } from '../../core/style/gstheme';

const message = [
  "Do you really want to delete this taxonomy?",
  "You have two choices for deletion.",
  "When you select 'Taxonomy Only' only the taxonomy gets deleted. Concepts and labels used within the taxonomy remain available for use in other taxonomies within the project.",
  "When you select 'Full Delete' the entire taxonomy is deleted. This includes the taxonomy and any concepts and labels that are in the concept scheme and not used in other taxonomies or collections.",
  "Note: Full deletion will not record any history and the taxonomy will be immediately permanently deleted. During full deletion the project will be locked."
];

class TaxonomyAreYouSure extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      open: true
    };
  }

  notSure = () => {
    this.setState({ open: false });
    this.props.onNotSure();
  };

  full = () => {
    this.setState({ open: false });
    this.props.onFull();
  };

  taxonomy = () => {
    this.setState({ open: false });
    this.props.onTaxonomy();
  };

  render() {

    const { classes } = this.props;

    return (
      <Dialog
        data-test="are-you-sure"
        open={this.state.open}
        onClose={this.notSure}
        aria-labelledby="areyousure-dialog-title" >
        <DialogTitle disableTypography className={classes.mainHeading} id="areyousure-dialog-title">How do you want to proceed?</DialogTitle>
        <DialogContent>
          {message.map((line, index) => <DialogContentText key={index}>{line}</DialogContentText>)}
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          <CancelButton dataTest="full-delete" onClick={this.full}>Full Delete</CancelButton>
          <CancelButton dataTest="taxonomy-only" onClick={this.taxonomy}>Taxonomy Only</CancelButton>
          <PrimaryButton onClick={this.notSure}>No</PrimaryButton>
        </DialogActions>
      </Dialog>
    );
  }
}

TaxonomyAreYouSure.propTypes = {
  onNotSure: PropTypes.func.isRequired,
  classes: PropTypes.object,
  onFull: PropTypes.func.isRequired,
  onTaxonomy: PropTypes.func.isRequired
};

export default withStyles(styles)(TaxonomyAreYouSure);